var $bdd847d8beb08799$exports = {};
$bdd847d8beb08799$exports = {
  "alpha": "Alpha",
  "black": "Schwarz",
  "blue": "Blau",
  "blue purple": "Blaulila",
  "brightness": "Helligkeit",
  "brown": "Braun",
  "brown yellow": "Braungelb",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "Cyan",
  "cyan blue": "Cyanblau",
  "dark": "dunkles",
  "gray": "Grau",
  "grayish": "gr\xE4uliches",
  "green": "Gr\xFCn",
  "green cyan": "Gr\xFCncyan",
  "hue": "Farbton",
  "light": "helles",
  "lightness": "Leuchtkraft",
  "magenta": "Magenta",
  "magenta pink": "Magentarosa",
  "orange": "Orange",
  "orange yellow": "Orangegelb",
  "pale": "blasses",
  "pink": "Rosa",
  "pink red": "Rosarot",
  "purple": "Lila",
  "purple magenta": "Lilamagenta",
  "red": "Rot",
  "red orange": "Rotorange",
  "saturation": "S\xE4ttigung",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", zu ").concat(args.percentTransparent, " transparent");
  },
  "very dark": "sehr dunkles",
  "very light": "sehr helles",
  "vibrant": "lebhaftes",
  "white": "Wei\xDF",
  "yellow": "Gelb",
  "yellow green": "Gelbgr\xFCn"
};
export { $bdd847d8beb08799$exports as default };